import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { AppLayout } from '../components/layout/AppLayout';
import { Card } from '../components/ui/Card';
import { LoadingSpinner } from '../components/ui/LoadingSpinner';
import { getHistory } from '../services/api';
import type { Analysis } from '../types';

export default function History() {
  const [analyses, setAnalyses] = useState<Analysis[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchHistory();
  }, []);

  const fetchHistory = async () => {
    try {
      setLoading(true);
      const data = await getHistory();
      setAnalyses(data);
    } catch (error) {
      console.error('Failed to fetch history:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <AppLayout>
        <div className="flex items-center justify-center min-h-[400px]">
          <LoadingSpinner size="lg" />
        </div>
      </AppLayout>
    );
  }

  return (
    <AppLayout>
      <div className="max-w-6xl mx-auto">
        <h1 className="text-3xl font-bold mb-8">Histórico de Análises</h1>

        {analyses.length === 0 ? (
          <Card className="p-12 text-center">
            <p className="text-gray-400 mb-4">Nenhuma análise encontrada</p>
            <Link to="/dashboard">
              <button className="gradient-blue px-6 py-3 rounded-lg hover:opacity-90 transition">
                Fazer Primeira Análise
              </button>
            </Link>
          </Card>
        ) : (
          <div className="grid grid-cols-1 gap-4">
            {analyses.map((analysis) => (
              <Link key={analysis.id} to={`/dashboard/analysis/${analysis.id}`}>
                <Card className="p-4 sm:p-6 hover:border-[#3B82F6] transition cursor-pointer">
                  <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                    <div className="flex-1 min-w-0">
                      <h3 className="font-semibold mb-2 text-sm sm:text-base break-all sm:truncate">{analysis.video_url}</h3>
                      <p className="text-xs sm:text-sm text-gray-400">
                        {new Date(analysis.created_at).toLocaleDateString('pt-BR', {
                          day: '2-digit',
                          month: '2-digit',
                          year: 'numeric',
                          hour: '2-digit',
                          minute: '2-digit'
                        })}
                      </p>
                    </div>
                    <div className="flex-shrink-0 sm:ml-4">
                      <span className={`inline-block px-3 py-1 rounded-full text-xs font-semibold whitespace-nowrap ${
                        analysis.status === 'completed' ? 'bg-green-500/20 text-green-400' :
                        analysis.status === 'failed' ? 'bg-red-500/20 text-red-400' :
                        analysis.status === 'processing' ? 'bg-yellow-500/20 text-yellow-400' :
                        'bg-gray-500/20 text-gray-400'
                      }`}>
                        {analysis.status === 'completed' ? 'Concluída' :
                         analysis.status === 'failed' ? 'Falhou' :
                         analysis.status === 'processing' ? 'Processando' :
                         analysis.status}
                      </span>
                    </div>
                  </div>
                </Card>
              </Link>
            ))}
          </div>
        )}
      </div>
    </AppLayout>
  );
}

